import Button from '@material-ui/core/Button';
import Error from 'Components/Error';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Loader from 'Components/Loader';
import React from 'react';
import Success from 'Components/Success';
import { Drawer, Select, MenuItem } from '@material-ui/core';
import { API_ROOT } from '../../../../api/Routes';

import API from '../../api';
import ProfileMachine from './stateMachine';
import Logo from './components/Logo';
import CloseBtn from './components/CloseBtn';
import FieldError from 'FieldError';
import { AccountCircle } from '@material-ui/icons';
import addresses from 'Addresses';

const regions = [
  {
    name: 'Europe',
    id: 'EUROPE',
  },
  {
    name: 'East Asia',
    id: 'EAST_ASIA',
  },
  {
    name: 'UKIMEA',
    id: 'UKIMEA',
  },
  {
    name: 'Americas',
    id: 'AMERICAS',
  },
  {
    name: 'Australasia',
    id: 'AUSTRALASIA',
  },
];

class EditProfileDrawer extends React.Component {
  imgUploadInput = React.createRef();

  state = {
    profile: null,
    error: null,
    viewState: ProfileMachine.initialState.value,
    logoPreview: null,
    avatarWillBeDeleted: false,
  };

  componentDidMount() {
    this.getUserProfile();
  }

  getUserProfile = () => {
    API.getUserProfile()
      .then(res => {
        this.setState({
          profile: res.data,
          viewState: ProfileMachine.transition(
            ProfileMachine.initialState.value,
            'PROFILE'
          ).value,
        });
      })
      .catch(err => {
        this.setState({
          error: err,
          viewState: ProfileMachine.transition(
            ProfileMachine.initialState.value,
            'ERROR'
          ).value,
        });
      });
  };

  updateField = (isRegion = false) => e => {
    e.persist();
    const input = isRegion ? e.target.name : e.target.getAttribute('name');
    if (input === 'region') {
      this.setState(state => ({
        ...state,
        profile: {
          ...state.profile,
          officeAddress: '',
        },
      }));
    }
    if (input === 'profileImage' && e.target.files && e.target.files[0]) {
      if (e.target.files[0].size > 5242880) {
        e.target.value = '';

        return this.setState(state => {
          return {
            ...state,
            viewState: ProfileMachine.transition(
              state.viewState,
              'PHOTO_SIZE_ERROR'
            ).value,
            avatarWillBeDeleted: false,
          };
        });
      }
      const reader = new FileReader();
      reader.onload = readEvent => {
        this.setState(state => {
          return {
            ...state,
            logoPreview: readEvent.target.result,
            profile: {
              ...state.profile,
              [input]: e.target.files[0],
            },
            avatarWillBeDeleted: false,
          };
        });
      };
      reader.readAsDataURL(e.target.files[0]);
    } else {
      this.setState(state => ({
        ...state,
        profile: {
          ...state.profile,
          [input]: e.target.value,
        },
      }));
    }
  };

  onUserProfileUpdate = () => {
    this.setState(
      state => ({
        viewState: ProfileMachine.transition(state.viewState, 'EDIT').value,
      }),
      () => {
        let form = new FormData();
        for (let prop in this.state.profile) {
          if (this.state.profile[prop] === null) {
            continue;
          }
          form.append(prop, this.state.profile[prop]);
        }

        API.updateUserProfile(form)
          .then(res => {
            if (this.state.avatarWillBeDeleted) {
              this.removeImage();
            }
            this.setState(
              state => ({
                viewState: ProfileMachine.transition(state.viewState, 'UPDATED')
                  .value,
              }),
              this.props.getCurentUser
            );
          })
          .catch(err => {
            this.setState(state => ({
              error: err,
              viewState: ProfileMachine.transition(state.viewState, 'ERROR')
                .value,
              avatarWillBeDeleted: false,
            }));
          });
      }
    );
  };

  onErrorCancel = () => {
    this.setState(state => ({
      error: null,
      viewState: ProfileMachine.transition(state.viewState, 'CANCEL').value,
    }));
  };

  onModalClose = () => {
    this.setState(state => ({
      viewState: ProfileMachine.transition(state.viewState, 'CONFIRM').value,
    }));
  };

  onDrawerClose = () => {
    this.props.onClose();
    this.getUserProfile();
    this.setState({
      logoPreview: null,
      avatarWillBeDeleted: false,
    });
  };

  removeImage = () => {
    if (this.state.profile.imageId) {
      API.deleteAsset(this.state.profile.imageId)
        .then(res => {
          this.setState(
            state => ({
              viewState: ProfileMachine.transition(state.viewState, 'UPDATED')
                .value,
              profile: {
                ...this.state.profile,
                imageId: null,
              },
              avatarWillBeDeleted: false,
            }),
            this.props.getCurentUser
          );
        })
        .catch(err => {
          this.setState(state => ({
            error: err,
            viewState: ProfileMachine.transition(state.viewState, 'ERROR')
              .value,
            avatarWillBeDeleted: false,
          }));
        });
    }
  };

  clearImage = () => {
    this.imgUploadInput.current.value = '';
    this.setState({
      avatarWillBeDeleted: true,
      logoPreview: null,
      profile: {
        ...this.state.profile,
        profileImage: null,
      },
    });
  };

  isSomeFieldEmpty = () => {
    if (
      !this.state.profile.firstName ||
      !this.state.profile.lastName ||
      !this.state.profile.officeAddress ||
      !this.state.profile.region ||
      !this.state.profile.mobilePhone
    ) {
      return true;
    }
    return false;
  };

  renderImage() {
    if (
      (!this.state.profile.imageId && !this.state.logoPreview) ||
      this.state.avatarWillBeDeleted
    ) {
      return <AccountCircle className="editProfileAvatar" />;
    }

    let image;
    if (this.state.logoPreview) {
      image = this.state.logoPreview;
    } else if (this.state.profile.imageId) {
      image = `${API_ROOT}/asset/${this.state.profile.imageId}`;
    }

    return (
      <Logo image={image} trigerRemoveImage={this.clearImage} showDeleteBtn />
    );
  }

  render() {
    if (!this.state.profile) {
      return <Loader isLoading />;
    }
    const {
      firstName,
      lastName,
      mobilePhone,
      officeAddress,
      workRole,
      mobileNumber,
      region,
    } = this.state.profile;

    return (
      <Drawer
        anchor="right"
        open={this.props.editProfile}
        onClose={this.onDrawerClose}
        classes={{
          paper: 'bc-gray u-pad-r-60 u-pad-l-60 mw540 t-align-c scroll-auto',
        }}
      >
        <Success
          open={this.state.viewState === 'updated'}
          message="Profile updated"
          handleClose={this.onModalClose}
        />
        {this.state.viewState === 'loading' ? <Loader isLoading /> : null}
        {this.state.viewState === 'error' ? (
          <Error onCancel={this.onErrorCancel} errors={this.state.error} />
        ) : null}

        {this.state.viewState === 'photo_size_error' ? (
          <Error
            onCancel={this.onErrorCancel}
            errors={'Image size cannot be greater then 5 MB'}
          />
        ) : null}
        <div>
          <CloseBtn onClick={this.onDrawerClose} />
          <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">
            Edit profile
          </h2>

          <div className="editProfileWrapper">
            {this.renderImage()}
            <input
              name="profileImage"
              type="file"
              onChange={this.updateField()}
              ref={this.imgUploadInput}
            />
          </div>

          <b className="c-s_gray t-primary-16 u-mrg-top-20 element-block">
            Add/change your profile picture
          </b>
          <div className="flexblock u-mrg-top-60">
            <FormControl fullWidth className="u-mrg-right-10">
              <InputLabel
                htmlFor="First name"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                First name
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="firstName"
                type="text"
                label="First name"
                value={firstName}
                onChange={this.updateField()}
              />
              {!this.state.profile.firstName && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
            <FormControl fullWidth className="u-mrg-left-10">
              <InputLabel
                htmlFor="Last name"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Last name
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="lastName"
                type="text"
                label="Last name"
                value={lastName}
                onChange={this.updateField()}
              />
              {!this.state.profile.lastName && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
          </div>
          <div className="flexblock u-mrg-top-30">
            <FormControl fullWidth className="u-mrg-right-10">
              <InputLabel
                htmlFor="Job position"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Job position
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="workRole"
                type="text"
                label="Job position"
                disabled
                value={workRole}
                onChange={this.updateField()}
              />
              {!this.state.profile.workRole && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="region"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Region
              </InputLabel>
              <Select
                id="region"
                fullWidth
                name="region"
                value={region}
                onChange={this.updateField(true)}
              >
                {regions.map(r => {
                  return (
                    <MenuItem key={r.id} value={r.id}>
                      {r.name}
                    </MenuItem>
                  );
                })}
              </Select>
              {!this.state.profile.region && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
          </div>
          <FormControl fullWidth className="u-mrg-top-30">
            <InputLabel
              htmlFor="Office"
              classes={{
                root: 'label--c-gray',
              }}
            >
              Office full address
            </InputLabel>
            {this.state.profile.hasArupDomain ? (
              <Select
                id="officeAddress"
                fullWidth
                name="officeAddress"
                value={officeAddress}
                onChange={this.updateField(true)}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {addresses
                  .filter(address => address.region === region)
                  .map(address => (
                    <MenuItem value={address.address} key={address.id}>
                      {address.address}
                    </MenuItem>
                  ))}
              </Select>
            ) : (
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="officeAddress"
                type="text"
                label="Office Address"
                value={officeAddress}
                onChange={this.updateField()}
              />
            )}
            {!this.state.profile.officeAddress && (
              <FieldError>This field can not be empty!</FieldError>
            )}
          </FormControl>
          <div className="flexblock u-mrg-top-30">
            <FormControl fullWidth className="u-mrg-right-10">
              <InputLabel
                htmlFor="phone"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Phone
              </InputLabel>
              <Input
                fullWidth
                classes={{
                  underline: 'underline--c-light',
                }}
                name="mobilePhone"
                type="text"
                label="Mobile phone"
                value={mobilePhone}
                onChange={this.updateField()}
              />
              {!this.state.profile.mobilePhone && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
            <FormControl fullWidth className="u-mrg-left-10">
              <InputLabel
                htmlFor="mobile"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Mobile number
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="mobileNumber"
                type="text"
                label="Mobile number"
                value={mobileNumber}
                onChange={this.updateField()}
              />
              {/* {!this.state.profile.mobileNumber && (
                <FieldError>This field can not be empty!</FieldError>
              )} */}
            </FormControl>
          </div>
        </div>
        <div>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className="t-weight-b pointer u-mrg-right-0 u-mrg-top-60 u-mrg-bot-60"
            onClick={this.onUserProfileUpdate}
            disabled={
              this.state.viewState === 'loading' || this.isSomeFieldEmpty()
            }
          >
            SAVE
          </Button>
        </div>
      </Drawer>
    );
  }
}

export default EditProfileDrawer;
